import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Orientation from '../algorithm/Orientation';
import Comparable from '../../../../java/lang/Comparable';
import Quadrant from './Quadrant';
import Assert from '../util/Assert';
var EdgeEnd = /*#__PURE__*/function () {
  function EdgeEnd() {
    _classCallCheck(this, EdgeEnd);
    EdgeEnd.constructor_.apply(this, arguments);
  }
  _createClass(EdgeEnd, [{
    key: "compareDirection",
    value: function compareDirection(e) {
      if (this._dx === e._dx && this._dy === e._dy) return 0;
      if (this._quadrant > e._quadrant) return 1;
      if (this._quadrant < e._quadrant) return -1;
      return Orientation.index(e._p0, e._p1, this._p1);
    }
  }, {
    key: "getDy",
    value: function getDy() {
      return this._dy;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._p0;
    }
  }, {
    key: "setNode",
    value: function setNode(node) {
      this._node = node;
    }
  }, {
    key: "print",
    value: function print(out) {
      var angle = Math.atan2(this._dy, this._dx);
      var className = this.getClass().getName();
      var lastDotPos = className.lastIndexOf('.');
      var name = className.substring(lastDotPos + 1);
      out.print('  ' + name + ': ' + this._p0 + ' - ' + this._p1 + ' ' + this._quadrant + ':' + angle + '   ' + this._label);
    }
  }, {
    key: "compareTo",
    value: function compareTo(obj) {
      var e = obj;
      return this.compareDirection(e);
    }
  }, {
    key: "getDirectedCoordinate",
    value: function getDirectedCoordinate() {
      return this._p1;
    }
  }, {
    key: "getDx",
    value: function getDx() {
      return this._dx;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._edge;
    }
  }, {
    key: "getQuadrant",
    value: function getQuadrant() {
      return this._quadrant;
    }
  }, {
    key: "getNode",
    value: function getNode() {
      return this._node;
    }
  }, {
    key: "toString",
    value: function toString() {
      var angle = Math.atan2(this._dy, this._dx);
      var className = this.getClass().getName();
      var lastDotPos = className.lastIndexOf('.');
      var name = className.substring(lastDotPos + 1);
      return '  ' + name + ': ' + this._p0 + ' - ' + this._p1 + ' ' + this._quadrant + ':' + angle + '   ' + this._label;
    }
  }, {
    key: "computeLabel",
    value: function computeLabel(boundaryNodeRule) {}
  }, {
    key: "init",
    value: function init(p0, p1) {
      this._p0 = p0;
      this._p1 = p1;
      this._dx = p1.x - p0.x;
      this._dy = p1.y - p0.y;
      this._quadrant = Quadrant.quadrant(this._dx, this._dy);
      Assert.isTrue(!(this._dx === 0 && this._dy === 0), 'EdgeEnd with identical endpoints found');
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._edge = null;
      this._label = null;
      this._node = null;
      this._p0 = null;
      this._p1 = null;
      this._dx = null;
      this._dy = null;
      this._quadrant = null;
      if (arguments.length === 1) {
        var edge = arguments[0];
        this._edge = edge;
      } else if (arguments.length === 3) {
        var _edge = arguments[0],
          p0 = arguments[1],
          p1 = arguments[2];
        EdgeEnd.constructor_.call(this, _edge, p0, p1, null);
      } else if (arguments.length === 4) {
        var _edge2 = arguments[0],
          _p = arguments[1],
          _p2 = arguments[2],
          label = arguments[3];
        EdgeEnd.constructor_.call(this, _edge2);
        this.init(_p, _p2);
        this._label = label;
      }
    }
  }]);
  return EdgeEnd;
}();
export { EdgeEnd as default };